import {
  CBM_PER_PALLET,
  getCartonsPerPallet,
  getPalletThreshold,
} from "../services/lmdRatesService";

/**
 * Resolve pallet count for pricing/invoice (matches Calculator + LMD auto mode).
 * Returns 0 when below pallet threshold and no stored pallets → carton shipment.
 */
export async function resolveBookingPalletCount(params: {
  totalCartons: number;
  totalVolume: number;
  storedPallets?: number | null;
}): Promise<number> {
  const { totalCartons, totalVolume, storedPallets } = params;

  if (storedPallets != null && storedPallets > 0) {
    return storedPallets;
  }

  const palletThreshold = await getPalletThreshold();
  if (totalCartons < palletThreshold) {
    return 0;
  }

  // Pallet mode: volume-based count (same rule as Calculator.tsx)
  return Math.max(1, Math.ceil(totalVolume / CBM_PER_PALLET) || 1);
}

export { getPalletThreshold, getCartonsPerPallet, CBM_PER_PALLET };
